/*
 * @Author: lizhigang
 * @Date: 2026-01-16 14:51:26
 * @Company: www.smm.cn
 * @Description: 通用处理cookie
 */

/**
 * 客户端设置 cookie（支持跨子域名共享）
 * @param name cookie 名称
 * @param value cookie 值
 * @param days 过期天数，不传则为 session cookie
 * @param domain cookie 域名
 */
export const setClientCookie = (name: string, value: string, days?: number, domain?: string) => {
  if (typeof document === "undefined") return

  let cookieString = `${name}=${encodeURIComponent(value)};path=/`

  if (domain) {
    cookieString += `;domain=${domain}`
  }

  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    cookieString += `;expires=${date.toUTCString()}`
  }

  cookieString += `;sameSite=lax`

  document.cookie = cookieString
}
